<template>
    <div id="uploadModelsModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content" @click.stop="">
            <div class="my-modal-header">
                <p style="font-weight: bold;font-size: 22px;">Upload Model</p>
                <span class="close" @click="onCloseClicked()"></span>
            </div>
            <div class="modal-body" style="padding:0;">
                <div class="modal-row">
                    <div class="dx-field">
                        <input type="text" v-virtual-keyboard name="name" v-model="modelToUpload.name" style="width: 100%;"
                               placeholder="Model Name" />
                    </div>
                </div>
                <div class="modal-row">
                    <div class="dx-field">
                        <input type="text" v-virtual-keyboard name="version" v-model="modelToUpload.version"
                               style="width: 100%;" placeholder="Model Version" />
                    </div>
                </div>
                <div class="modal-row toggle-row">
                    <label>Is SVF2</label>
                    <CustomCheckbox :is_checked="modelToUpload.isSvf2" :name="'isSvf2'"
                                    @check_changed="modelToUpload.isSvf2 = $event.value"></CustomCheckbox>
                </div>

                <div class="modal-row toggle-row">
                    <label>Upload in chunks</label>
                    <CustomCheckbox :is_checked="modelToUpload.uploadInChunks" :name="'uploadInChunks'"
                                    @check_changed="modelToUpload.uploadInChunks = $event.value"></CustomCheckbox>
                </div>

                <div class="modal-row">
                    <div v-if="selectedFile" style="padding-top: 10px;">{{ selectedFile.name }}</div>
                    <div v-if="!selectedFile" style="padding-top: 10px;">No File Selected</div>
                    <input type="file" style="display: none;" id="browseModelFile" @change="onFileChanged($event)">

                </div>
                <div class="modal-row">
                    <div class="admin-btn admin-btn-secondary" @click="broswe()">Select File</div>
                </div>
                <progress style="width: 100%;height: 20px;" v-if="isUploading" min="0" :max="maxProgress_modls" step="1"
                          :value="progress_models"></progress>
            </div>
            <div class="modal-footer">
                <div class="admin-btn admin-btn-secondary" @click="onCloseClicked()">Close</div>
                <div class="admin-btn" @click="uploadForgeModel()">Upload</div>
            </div>
        </div>

    </div>
</template>

<script>
    import { ForgeModelVersion } from '@/scripts/js/forgeModels'
    import CustomCheckbox from '@/components/common/customCheckbox.vue'
    import { monitorTranslationStatus } from '@/utils/forgeUtils'
    export default {
        name: 'UploadModels',
        components: {
            CustomCheckbox
        },
        props: ['assetId'],
        data() {
            return {
                modelToUpload: new ForgeModelVersion(),
                progress_models: 0,
                selectedFile: null,
                isUploading: false,
                maxProgress_modls: 100,
            }
        },
        methods: {
            onFileChanged(event) {
                if (event.target.files.length == 0) {
                    this.selectedFile = null;
                    return;
                }
                this.selectedFile = event.target.files[0];
            },
            broswe() {
                document.getElementById('browseModelFile').click();
            },
            onCloseClicked() {
                document.getElementById("uploadModelsModal").style.display = "none";
            },
            uploadForgeModel() {
                console.log(this.modelToUpload.uploadInChunks)
                if (!this.selectedFile) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: "Please select file first."
                    })
                    return;
                }
                if (!this.modelToUpload.name) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: "Please Enter the model name."
                    })
                    return;
                }
                if (this.$store.state.uploadedModels.some(o => o.name == this.modelToUpload.name)) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: "Name is already existing, please change a unique name."
                    })
                    return;
                }
                if (!this.modelToUpload.version) {
                    this.$store.dispatch({
                        type: "alert_Forge",
                        message: "Please Enter the model version."
                    })
                    return;
                }
                this.progress_models = 0;
                this.maxProgress_modls = 100;
                this.isUploading = true;

                var onProgress = (progress, maxProgress) => {
                    this.progress_models = progress;
                    this.maxProgress_modls = maxProgress;
                };
                this.$store.state.forgeService.uploadVersionToAsset(!!this.modelToUpload.uploadInChunks, this.assetId, this.modelToUpload, this.selectedFile, onProgress,
                    version => {
                        this.isUploading = false;
                        this.$store.state.uploadedModels.forEach(o => o.isMainVersion = false);
                        version.isMainVersion = true;
                        this.$store.state.uploadedModels.push(version);
                        this.$emit('dispose3DViewer');
                        this.modelToUpload = new ForgeModelVersion();
                        document.getElementById("uploadModelsModal").style.display = "none";
                        this.$store.dispatch({ type: 'showSuccessfulMessage', message: "Model uploaded successfully.", timeout: 3000 })

                        monitorTranslationStatus(version.urn)
                            .then(() => {
                                this.$store.dispatch({
                                    type: 'showSuccessfulMessage',
                                    message: "Translation finished successfully.",
                                    timeout: 3000
                                })
                                this.$emit("launch-viewer", version, true);
                            })
                            .catch(() => {
                                this.$store.dispatch({
                                    type: "alert_Forge",
                                    message: "Translation not ready. Please update tags using Tag Harvester once the model is ready."
                                })
                            });
                    },
                    error => {
                        console.log(error)
                        this.isUploading = false;
                        this.$store.dispatch({
                            type: "alert_Forge",
                            message: "Uploading failed, please try again later."
                        })
                    });
            }

        },
    }
</script>

<style>
    #uploadModelsModal .modal-content {
        height: 400px;
    }

    .toggle-row {
        display: flex;
        align-items: center;
    }
</style>
